import { FormFieldTypes } from "../../../data/formFieldType";
export const CertificateIssuanceFormData = {
  name: "XeroPaymentUpdatelistForm",
  initialState: {
    companyName: null,
    paymentStatus: null,
  },
  formFields: [
    {
      id: "companyName",
      lable: "Search by Company Name /Cert Number",
      Field_Name: "Company Name",
      fieldType: FormFieldTypes.INPUT,
      dataField: "companyName",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      style: {
        containerCss:
          "col-lg-6 col-xl-6 col-md-6 col-sm-12 col-12 mb-3 ",
      },
    },
    {
      id: "searchByStatus",
      lable: "Search by Status",
      Field_Name: "Search by Status",
      fieldType: FormFieldTypes.SELECT,
      dataField: "searchByStatus",
      fieldSetting: {
        placeholder: "Select",
        options: [
          {
            label: "All",

            value: 1,
          },
          {
            label: "Pending MUA / Invoice",
            value: 2,
          },
          {
            label: "Finalisation",
            value: 3,
          },
          {
            label: "Issued",
            value: 4,
          },
        ],
      },
      style: {
        containerCss:
          "col-lg-6 col-xl-6 col-md-6 col-sm-12 col-12 mb-3 xero-filters",
      },
    },
  ],
  formSetting: {
    isViewOnly: false,
  },
};
